import './scss/AggieBootstrap.scss';
import './scss/styles.scss';
import jquery from 'jquery'
const jQuery = jquery;
const $ = jQuery;
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
window.bootstrap = bootstrap;
import Enumerable from 'linq';
window.Enumerable = Enumerable;
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import calendar from 'dayjs/plugin/calendar';
import lfmt from 'dayjs/plugin/localizedFormat';
import tz from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import { v4 as uuidv4 } from 'uuid';
import 'bootstrap-icons/font/bootstrap-icons.css';
window.uuidv4 = uuidv4;
dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(lfmt);
dayjs.extend(tz);
dayjs.extend(weekday);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    calendar: {
        sameDay: '[Today at] h:mm:ss A',
        nextDay: '[Tomorrow at] h:mm:ss A',
        nextWeek: 'dddd [at] h:mm:ss A',
        lastDay: '[Yesterday at] h:mm:ss A',
        lastWeek: 'dddd [at] h:mm:ss A',
        sameElse: 'MM/DD/YYYY [at] h:mm:ss A'
    }
});
window.dayjs = dayjs;

import axios from 'axios';
window.axios = axios;
if ($("input[name=AggieRing_XSRF]").length > 0) {
    console.log('creating ring api');
    window.ringApi = window.axios.create({
        headers: { 'X-XSRF-TOKEN': $("input[name=AggieRing_XSRF]").val() }
    });
}
/*import { Vue } from 'vue/dist/vue.global.js';
window.Vue = Vue;*/
//window.Vue = Vue;
//Vue.createApp({});
/*import App from './App.vue'*/
/*createApp(App).mount('#app')*/